export default __webpack_public_path__ + "static/media/custom3w.62995ed4.png";